// PsyPractice — hukuki belgeler / Polski.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir —
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Jednoosobowa działalność gospodarcza";

const OWNER = 'PsyPractice (dalej „Platforma” lub „Administrator danych”)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Warunki korzystania i zastrzeżenie odpowiedzialności",
    description:
      "Charakter i granice usługi, to, czego nie zastępuje, zobowiązania użytkownika oraz kompleksowe zrzeczenie się roszczeń przenoszące całą odpowiedzialność na użytkownika.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Strony i akceptacja",
        paras: [
          `Niniejsze Warunki korzystania zostają zawarte pomiędzy ${OWNER} a każdą osobą fizyczną lub prawną, która uzyskuje dostęp do Platformy lub w jakikolwiek sposób z niej korzysta („Użytkownik”). Zakładając konto, logując się lub korzystając z Platformy w jakikolwiek sposób, Użytkownik potwierdza, że zapoznał się z niniejszymi Warunkami, zrozumiał je oraz bezwarunkowo akceptuje je i zobowiązuje się do ich przestrzegania w całości. Osoba, która nie akceptuje niniejszych Warunków, nie może korzystać z Platformy.`,
        ],
      },
      {
        heading: "2. Charakter i granice usługi",
        bullets: [
          "PsyPractice jest oprogramowaniem do SYMULACJI pacjenta wspieranej sztuczną inteligencją, które pozwala studentom psychologii i początkującym klinicystom prowadzić i zapisywać własną praktykę prowadzenia rozmowy w bezpiecznym środowisku.",
          "PsyPractice nie jest usługą edukacyjną ani szkoleniową; jest narzędziem programistycznym, które pozwala użytkownikowi prowadzić i zapisywać własną praktykę. Platforma nie zapewnia zajęć, programu nauczania, egzaminów ani dokumentów i nie nadaje jakiegokolwiek tytułu, kwalifikacji ani uprawnienia.",
          "Symulowany „pacjent” nie jest prawdziwym klientem; jego wypowiedzi są generowane przez sztuczną inteligencję, mogą być błędne, niepełne, niespójne lub mylące i nie niosą żadnego twierdzenia co do trafności klinicznej ani prawdziwości.",
        ],
      },
      {
        heading: "2.1. Czego Platforma nie zastępuje",
        bullets: [
          "NIE jest prawdziwą terapią ani poradnictwem i nie zastępuje żadnej sesji prowadzonej z prawdziwym klientem.",
          "NIE zastępuje superwizji klinicznej. Raporty zwrotne tworzone przez superwizora AI są tekstem generowanym automatycznie; nie są opinią biegłego, oceną urzędową ani stopniem.",
          "NIE jest narzędziem diagnostycznym, przesiewowym ani oceniającym; żaden wynik Platformy nie może być wykorzystywany do diagnozy ani do podejmowania decyzji klinicznych dotyczących jakiejkolwiek prawdziwej osoby.",
          "NIE WOLNO korzystać z niej w sytuacjach kryzysowych ani nagłych. W przypadku myśli samobójczych, ryzyka wyrządzenia krzywdy sobie lub innym albo innej porównywalnej sytuacji nagłej należy zamknąć Platformę i niezwłocznie skontaktować się z lokalnymi służbami ratunkowymi lub właściwą placówką ochrony zdrowia.",
          "NIE jest źródłem kompetencji zawodowych, licencji, tytułu ani uprawnień; czas spędzony na Platformie ani jej wyniki nie mogą być przedstawiane jakiejkolwiek instytucji jako dowód kwalifikacji.",
        ],
      },
      {
        heading: "3. Oświadczenia i zobowiązania Użytkownika",
        bullets: [
          "Użytkownik zobowiązuje się korzystać z Platformy wyłącznie w granicach prawa i etyki, w celu rozwijania własnej praktyki zawodowej.",
          "Użytkownik zobowiązuje się NIE wprowadzać jakichkolwiek PRAWDZIWYCH danych pacjenta/klienta, danych identyfikujących ani danych o zdrowiu należących do szczególnych kategorii, dotyczących jakiejkolwiek osoby; wszelkie skutki prawne takiego działania obciążają wyłącznie Użytkownika.",
          "Użytkownik zobowiązuje się nie wykorzystywać jakiegokolwiek wyniku uzyskanego z Platformy do diagnozy, leczenia, interwencji ani podejmowania decyzji klinicznych dotyczących jakiejkolwiek prawdziwej osoby.",
          "Użytkownik ponosi wyłączną odpowiedzialność za własne kompetencje zawodowe, zakres uprawnień oraz zgodność z obowiązującymi przepisami zawodowymi i etycznymi.",
          "Bezpieczeństwo konta, poufność hasła oraz wszelka aktywność prowadzona na koncie Użytkownika pozostają w odpowiedzialności Użytkownika.",
          "Konto jest osobiste; Użytkownik zobowiązuje się nie udostępniać go innym osobom i nie korzystać z Platformy za pomocą środków zautomatyzowanych (boty, skrypty itp.). Korzystanie z planów płatnych podlega limitowi uczciwego korzystania (obecnie 60 sesji w miesiącu kalendarzowym), opisanemu szczegółowo w Umowie sprzedaży na odległość.",
        ],
      },
      {
        heading: "4. Całość odpowiedzialności spoczywa na Użytkowniku (zrzeczenie się roszczeń)",
        paras: [
          "Platforma jest udostępniana w stanie „TAKIM, JAKI JEST” (AS IS) oraz „W MIARĘ DOSTĘPNOŚCI” (AS AVAILABLE), bez jakiejkolwiek wyraźnej ani dorozumianej gwarancji (w tym gwarancji nieprzerwanego działania, bezbłędności, przydatności do określonego celu, dokładności czy aktualności).",
          "Użytkownik przyjmuje do wiadomości i zobowiązuje się, że ponosi WYŁĄCZNĄ i OSOBISTĄ odpowiedzialność za wszelkie szkody bezpośrednie, pośrednie, uboczne, szczególne lub następcze (w tym szkody majątkowe, niemajątkowe, szkody dla reputacji zawodowej, utratę danych, utratę przychodów oraz szkody wyrządzone osobom trzecim) wynikające z korzystania lub niemożności korzystania z Platformy, z polegania na wynikach sztucznej inteligencji albo z zastosowania takich wyników w jakikolwiek sposób.",
          "W najszerszym zakresie dopuszczalnym przez obowiązujące prawo Użytkownik niniejszym nieodwołalnie i bezwarunkowo ZRZEKA SIĘ — już teraz i z góry — wszelkich roszczeń, powództw i praw do odszkodowania, które mógłby podnieść wobec Platformy, jej właścicieli, pracowników, twórców, partnerów biznesowych i dostawców usług w związku z jakąkolwiek szkodą, jakiej mógłby doznać w razie wystąpienia niekorzystnego skutku.",
          "Użytkownik zobowiązuje się ponadto do pełnego zwolnienia Platformy z odpowiedzialności i zaspokojenia (indemnizacji) wszelkich roszczeń, szkód, kar i kosztów (w tym kosztów zastępstwa procesowego), jeżeli do Platformy zwróci się jakakolwiek osoba trzecia lub instytucja z powodu winy, zaniedbania albo korzystania z Platformy przez Użytkownika z naruszeniem niniejszych Warunków.",
        ],
      },
      {
        heading: "5. Ograniczenie odpowiedzialności",
        paras: [
          "Bez uszczerbku dla bezwzględnie obowiązujących przepisów prawa całkowita odpowiedzialność prawna Platformy jest w każdym przypadku ograniczona do kwoty faktycznie zapłaconej Platformie przez Użytkownika w ciągu 12 miesięcy poprzedzających zdarzenie stanowiące podstawę danego roszczenia. W przypadku korzystania nieodpłatnego kwota ta wynosi zero.",
        ],
      },
      {
        heading: "6. Własność intelektualna, zmiany i zakończenie świadczenia",
        bullets: [
          "Wszelkie prawa własności intelektualnej do Platformy, jej oprogramowania, projektu graficznego, szablonów przypadków pacjentów oraz treści przysługują Platformie.",
          "Wszelkie zbywalne majątkowe prawa własności intelektualnej do treści tworzonych przez Użytkownika na Platformie (w tym do pisanych przez niego wypowiedzi terapeuty, zapisów sesji i materiałów z nich wywiedzionych) uznaje się za przeniesione na Platformę na zasadzie wyłączności, bezterminowo i bez wynagrodzenia z chwilą powstania takich treści; Platforma może wykorzystywać, zwielokrotniać i przetwarzać te treści na całym świecie i bez ograniczeń w jakimkolwiek celu, w tym w celu świadczenia usługi, generowania informacji zwrotnej oraz ulepszania i rozwijania systemu (w tym doskonalenia uczenia maszynowego). Przeniesienie to nie narusza praw Użytkownika dotyczących danych osobowych, wynikających z obowiązujących przepisów o ochronie danych (RODO / KVKK), które pozostają zastrzeżone.",
          "Platforma zastrzega sobie prawo do zmiany, zawieszenia lub zaprzestania obowiązywania niniejszych Warunków oraz zmiany zakresu usługi w dowolnym czasie, bez uprzedniego powiadomienia.",
          "W razie naruszenia niniejszych Warunków Platforma może zawiesić lub zamknąć konto bez uprzedniego powiadomienia.",
        ],
      },
      {
        heading: "7. Prawo właściwe i jurysdykcja",
        paras: [
          "Niniejsze Warunki podlegają prawu Republiki Turcji. Do rozpoznania wszelkich mogących powstać sporów właściwe są sądy i organy egzekucyjne Republiki Turcji.",
          "W odniesieniu do konsumentów zamieszkałych w Unii Europejskiej zastrzega się ochronę wynikającą z bezwzględnie obowiązujących przepisów o ochronie konsumentów ich państwa zamieszkania oraz z przysługujących im na podstawie RODO praw do ochrony danych; niniejszy wybór prawa nie uchyla tych bezwzględnie obowiązujących przepisów.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Polityka prywatności",
    description:
      "RODO jako standard bazowy; przetwarzane dane, podstawy prawne, hosting w UE, transfery międzynarodowe (dostawca AI) oraz klauzula transferu za granicę z art. 9 KVKK dla użytkowników w Turcji.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Niniejsza Polityka prywatności wyjaśnia, w jaki sposób przetwarzane są dane osobowe w ramach Platformy prowadzonej przez ${OWNER}. Jako bazowy standard ochrony danych polityka przyjmuje unijne ogólne rozporządzenie o ochronie danych (RODO / GDPR, 2016/679); wobec użytkowników znajdujących się w Turcji dodatkowo stosuje się turecką ustawę nr 6698 o ochronie danych osobowych (KVKK) — w szczególności jej art. 9 dotyczący transferu za granicę. Informacja KVKK oraz Oświadczenie o zgodzie wyraźnej stanowią integralne części niniejszej polityki.`,
        ],
      },
      {
        heading: "Administrator danych i lokalizacja hostingu",
        bullets: [
          "Administrator danych: PsyPractice. Żądania osób, których dane dotyczą, są obsługiwane kanałem kontaktowym ogłoszonym na Platformie (adres kontaktowy: info@psycora.com).",
          "Hosting: Platforma i jej baza danych są utrzymywane na terenie Unii Europejskiej — w centrum danych w Holandii (Oracle Cloud). W przypadku użytkowników znajdujących się w UE/EOG dane są przetwarzane i przechowywane na terenie UE.",
          "Dostawca hostingu działa wyłącznie jako podmiot przetwarzający, na podstawie zawartej umowy powierzenia przetwarzania danych (DPA).",
        ],
      },
      {
        heading: "Zbierane dane",
        bullets: [
          "Dane konta: imię i nazwisko, adres e-mail, zahaszowane hasło, informacje o subskrypcji/planie.",
          "Dane o korzystaniu: utworzone sesje, zapisy sesji, wygenerowane przypadki pacjentów, raporty zwrotne superwizora.",
          "Dane techniczne: zapisy sesji logowania, adres IP, preferencje przeglądarki i języka, logi limitów żądań i bezpieczeństwa.",
        ],
      },
      {
        heading: "Cele przetwarzania i podstawa prawna (art. 6 RODO)",
        bullets: [
          "Wykonanie umowy (art. 6 ust. 1 lit. b): założenie konta, prowadzenie sesji, pamięć pacjenta obejmująca wiele sesji, ocena superwizora, zarządzanie subskrypcją i limitami korzystania.",
          "Prawnie uzasadniony interes (art. 6 ust. 1 lit. f): bezpieczeństwo, zapobieganie nadużyciom, ulepszanie systemu i usuwanie błędów.",
          "Obowiązek prawny (art. 6 ust. 1 lit. c): przechowywanie i raportowanie wynikające z przepisów.",
          "Zgoda (art. 6 ust. 1 lit. a): przetwarzanie analityczne i służące ulepszaniu produktu, które nie jest ściśle niezbędne do świadczenia usługi, oraz — gdy jest to wymagane — transfer poza UE/EOG.",
        ],
      },
      {
        heading: "Transfery międzynarodowe",
        paras: [
          "Ponieważ hosting znajduje się na terenie UE (Holandia), dane użytkowników z UE/EOG są co do zasady przetwarzane na terenie UE i na tej warstwie nie są przekazywane do państwa trzeciego. Jednak w celu wygenerowania odpowiedzi sztucznej inteligencji treść sesji i polecenia są przesyłane do dostawcy usług AI (Anthropic), którego infrastruktura przetwarzania może znajdować się poza UE/EOG (np. w Stanach Zjednoczonych).",
          "Takie transfery poza UE/EOG opierają się na odpowiednich zabezpieczeniach przewidzianych w art. 44 i nast. RODO — w szczególności na standardowych klauzulach umownych (SCC) Komisji Europejskiej — a z dostawcą zawarto umowę powierzenia przetwarzania danych (DPA). Platforma NIE sprzedaje danych osobowych w celach marketingowych; dane nie są udostępniane osobom trzecim poza przypadkami ściśle niezbędnymi do świadczenia usługi (z zastrzeżeniem zgodnych z prawem żądań właściwych organów).",
        ],
      },
      {
        heading: "Dla użytkowników w Turcji — art. 9 KVKK (transfer za granicę)",
        paras: [
          "Dane osobowe użytkowników znajdujących się w Turcji są przekazywane poza Turcję, ponieważ hosting znajduje się w Holandii (UE), i mogą być również przekazywane do Anthropic w celu przetwarzania przez sztuczną inteligencję. Transfery te podlegają art. 9 KVKK i opierają się na odpowiednich zabezpieczeniach (standardowa umowa lub zobowiązanie opublikowane przez Radę) albo — gdy jest to wymagane — na Państwa zgodzie wyraźnej. Zakres, odbiorcy i cel transferu zostały szczegółowo opisane w Informacji KVKK oraz w Oświadczeniu o zgodzie wyraźnej.",
        ],
      },
      {
        heading: "Prawa osoby, której dane dotyczą (art. 15–22 RODO)",
        bullets: [
          "Dostęp do danych, ich sprostowanie, usunięcie („prawo do bycia zapomnianym”) oraz ograniczenie przetwarzania.",
          "Przenoszenie danych: otrzymanie dostarczonych przez Państwa danych w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego.",
          "Sprzeciw: wniesienie sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie oraz wobec marketingu bezpośredniego.",
          "Prawa związane z decyzjami opierającymi się wyłącznie na zautomatyzowanym przetwarzaniu, w tym profilowaniu.",
          "Wycofanie zgody w dowolnym momencie w przypadku przetwarzania opartego na zgodzie (wycofanie nie wpływa na zgodność z prawem przetwarzania dokonanego do tego momentu).",
          "Prawo wniesienia skargi do organu nadzorczego: właściwego organu ochrony danych w UE; w Turcji — Urzędu Ochrony Danych Osobowych (KVKK).",
        ],
      },
      {
        heading: "Przechowywanie i bezpieczeństwo",
        bullets: [
          "Dane są przechowywane tak długo, jak wymaga tego cel przetwarzania, oraz przez okresy przewidziane obowiązującymi przepisami; po upływie tego okresu są usuwane lub anonimizowane.",
          "Pola wrażliwe (np. hasło, kody weryfikacyjne i resetujące) są przechowywane w postaci zaszyfrowanej lub zahaszowanej; dostęp do nich jest oparty na uprawnieniach.",
          "Ponieważ żadna metoda przesyłania ani przechowywania nie jest w 100% bezpieczna, nie można zagwarantować bezwzględnego bezpieczeństwa.",
        ],
      },
      {
        heading: "Zakaz wprowadzania danych prawdziwych pacjentów",
        paras: [
          "Platforma jest oprogramowaniem symulacyjnym; wprowadzanie danych osobowych i danych o zdrowiu należących do prawdziwych klientów jest zabronione. Wszelka odpowiedzialność wynikająca z wprowadzenia przez Użytkownika danych z naruszeniem tego zakazu spoczywa wyłącznie na Użytkowniku.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Informacja KVKK",
    description:
      "Administrator danych, cele przetwarzania, podstawa prawna, transfer oraz prawa osoby, której dane dotyczą, zgodnie z art. 10 ustawy nr 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Administrator danych",
        paras: [
          `Zgodnie z art. 10 tureckiej ustawy nr 6698 o ochronie danych osobowych („KVKK”) Państwa dane osobowe są przetwarzane przez ${OWNER}, występującą w charakterze Administratora danych, w zakresie opisanym poniżej.`,
        ],
      },
      {
        heading: "Przetwarzane dane i cele",
        bullets: [
          "Dane identyfikacyjne i kontaktowe (imię i nazwisko, adres e-mail): założenie konta, uwierzytelnianie, komunikacja.",
          "Dane transakcji klienta (subskrypcja, plan, korzystanie): świadczenie usługi, rozliczenia, egzekwowanie limitów.",
          "Bezpieczeństwo transakcji (sesja, adres IP, logi): bezpieczeństwo, zapobieganie nadużyciom, obowiązek prawny.",
          "Treści Użytkownika (zapisy sesji, wygenerowane przypadki): świadczenie usługi programistycznej i generowanie informacji zwrotnej.",
          "Członkostwo w grupie instytucjonalnej (identyfikator grupy, okres członkostwa): w przypadku dołączenia użytkownika do grupy prowadzonej przez instytucję — widoczność dla prowadzącego oraz administrowanie grupą.",
        ],
      },
      {
        heading: "Podstawa prawna (art. 5)",
        bullets: [
          "Zawarcie lub wykonanie umowy: dane niezbędne do świadczenia usługi.",
          "Prawnie uzasadniony interes administratora danych: bezpieczeństwo, zapobieganie oszustwom, ulepszanie systemu.",
          "Obowiązek prawny: przechowywanie i raportowanie wynikające z przepisów.",
          "Zgoda wyraźna: transfer za granicę (art. 9) oraz dodatkowe przetwarzanie, które nie jest ściśle niezbędne do świadczenia usługi.",
        ],
      },
      {
        heading: "Transfer za granicę (art. 9)",
        paras: [
          "Ponieważ Platforma i jej baza danych są utrzymywane na terenie Unii Europejskiej — w centrum danych w Holandii (Oracle Cloud) — dane osobowe użytkowników znajdujących się w Turcji są przekazywane poza Turcję (do UE). Ponadto w celu wygenerowania odpowiedzi sztucznej inteligencji treść sesji i polecenia mogą być przekazywane do dostawcy usług AI (Anthropic), którego infrastruktura przetwarzania może znajdować się poza UE/EOG (np. w Stanach Zjednoczonych).",
          "Transfery te podlegają art. 9 KVKK i opierają się na odpowiednich zabezpieczeniach — takich jak standardowa umowa lub zobowiązanie opublikowane przez Radę — albo, gdy jest to wymagane, na Państwa zgodzie wyraźnej. Z dostawcami hostingu i usług zawarto umowy powierzenia przetwarzania danych (DPA).",
        ],
      },
      {
        heading: "Grupy instytucjonalne i widoczność dla prowadzącego",
        paras: [
          "Jeżeli dołączą Państwo do grupy otwartej przez uczelnię, poradnię lub podobną instytucję, treść Państwa sesji (zapisy rozmów) oraz raporty superwizyjne mogą być widoczne dla prowadzącego tę grupę przez czas jej trwania. Widoczność ta obejmuje wyłącznie Państwa sesje powiązane z grupą i kończy się wraz z zakończeniem członkostwa w grupie.",
          "Dostęp ten uzyskiwany jest poprzez ODRĘBNY ekran zgody wyraźnej, wyświetlany przy dołączaniu do grupy; nie jest częścią ogólnej akceptacji warunków Platformy. Bez udzielenia tej zgody nie można dołączyć do grupy, ale można nadal korzystać z Platformy indywidualnie dokładnie tak jak wcześniej. Wycofanie zgody kończy członkostwo w grupie i nie wpływa na indywidualne korzystanie z Platformy.",
        ],
      },
      {
        heading: "Prawa osoby, której dane dotyczą (art. 11)",
        bullets: [
          "Prawo do uzyskania informacji, czy Państwa dane osobowe są przetwarzane, a jeśli tak — do żądania informacji na ich temat.",
          "Prawo do poznania celu przetwarzania i tego, czy dane są wykorzystywane zgodnie z tym celem.",
          "Prawo do poznania osób trzecich, którym dane są przekazywane w kraju lub za granicę.",
          "Prawo do żądania sprostowania niepełnego lub nieprawidłowego przetwarzania oraz — po spełnieniu przesłanek — usunięcia lub zniszczenia danych.",
          "Prawo do sprzeciwu wobec niekorzystnego dla Państwa rozstrzygnięcia wynikającego wyłącznie z analizy zautomatyzowanej.",
          "Prawo do żądania naprawienia szkody poniesionej wskutek niezgodnego z prawem przetwarzania.",
        ],
      },
      {
        heading: "Wnioski",
        paras: [
          "Żądania dotyczące Państwa praw mogą być składane kanałem kontaktowym ogłoszonym przez Administratora danych. Wnioski są rozpatrywane w terminach przewidzianych w KVKK i przepisach wykonawczych.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Oświadczenie o zgodzie wyraźnej",
    description:
      "Odrębne od obowiązku informacyjnego; zgoda udzielona dobrowolnie na transfer za granicę i przetwarzanie przez sztuczną inteligencję.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Oświadczam, że zapoznałam/zapoznałem się z Informacją KVKK i ją rozumiem oraz że dobrowolnie, w sposób świadomy i wyraźny wyrażam zgodę na opisane poniżej przetwarzanie. (Zgodnie z decyzją Rady KVKK nr 2018/90 zgoda wyraźna jest odbierana odrębnie od obowiązku informacyjnego).",
        ],
      },
      {
        heading: "Przetwarzanie objęte zgodą",
        bullets: [
          "Przekazywanie moich danych osobowych poza Turcję oraz ich przechowywanie i przetwarzanie tam, ponieważ Platforma jest utrzymywana w Unii Europejskiej (Holandia / Oracle Cloud) (art. 9 KVKK).",
          "Przekazywanie i przetwarzanie zapisów moich sesji i poleceń u dostawcy usług AI (Anthropic), którego infrastruktura przetwarzania może znajdować się poza UE/EOG, w celu generowania odpowiedzi sztucznej inteligencji (art. 9 KVKK).",
          "Przetwarzanie na potrzeby ulepszania produktu i analityki, które nie jest ściśle niezbędne do świadczenia usługi.",
          "Otrzymywanie powiadomień związanych z usługą.",
        ],
      },
      {
        heading: "Wycofanie zgody",
        paras: [
          "Przyjmuję do wiadomości, że mogę w dowolnym momencie wycofać moją zgodę wyraźną; ponieważ jednak transfer za granicę do dostawcy AI jest technicznie wymagany do działania usługi, akceptuję, że wycofanie tej zgody może skutkować brakiem możliwości korzystania z odpowiednich funkcji lub z usługi jako całości. Wycofanie nie wpływa na zgodność z prawem przetwarzania dokonanego do dnia wycofania.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice — see the comment there.
    id: "outreach",
    title: "Informacja o korespondencji wychodzącej",
    description:
      "Dla pracowników naukowych i osób kontaktowych w instytucjach, które otrzymały firmową wiadomość kontaktową: skąd pochodzą dane, dlaczego są przetwarzane, jaka jest podstawa prawna i jak zrezygnować.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Niniejsza informacja jest kierowana do odbiorców firmowych wiadomości kontaktowych wysyłanych przez PsyPractice do uczelnianych katedr psychologii i ich pracowników naukowych, zgodnie z art. 10 tureckiej ustawy nr 6698 o ochronie danych osobowych (KVKK) oraz z Komunikatem w sprawie trybu i zasad wypełniania obowiązku informacyjnego. Ponieważ Państwa dane osobowe nie zostały pozyskane bezpośrednio od Państwa, informacja jest przekazywana najpóźniej w chwili pierwszego kontaktu — dlatego wiadomość kontaktowa odsyła do tej strony.",
        ],
      },
      {
        heading: "1. Administrator danych",
        bullets: [
          `Nazwa: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.addressEn}`,
          `Urząd skarbowy / numer podatkowy: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Strona internetowa: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Przetwarzane dane i ich źródło",
        paras: [
          "Przetwarzanie ogranicza się do zawodowych danych kontaktowych: imienia i nazwiska, tytułu naukowego, uczelni i katedry, instytucjonalnego adresu e-mail oraz — jeżeli został opublikowany — instytucjonalnego numeru telefonu.",
          "Dane te nie zostały zebrane od Państwa, lecz zestawione z publicznie opublikowanych oficjalnych stron katedr i wydziałów uczelni. Nie są przetwarzane dane szczególnych kategorii, a prywatne (pozainstytucjonalne) adresy e-mail nie są wykorzystywane do kontaktu.",
        ],
      },
      {
        heading: "3. Cel",
        paras: [
          "Państwa dane są przetwarzane w celu przedstawienia narzędzia programistycznego stworzonego z myślą o studentach psychologii, zaproszenia Państwa katedry do ewentualnej rozmowy o pilotażu lub współpracy oraz prowadzenia związanej z tym korespondencji. Nie są wykorzystywane w żadnym innym celu, nie są sprzedawane ani przekazywane osobom trzecim do celów marketingowych.",
        ],
      },
      {
        heading: "4. Podstawa prawna",
        paras: [
          "Przetwarzanie opiera się na prawnie uzasadnionych interesach administratora danych na podstawie art. 5/2-(f) KVKK, pod warunkiem że nie narusza to Państwa podstawowych praw i wolności: kontakt następuje wyłącznie na adres instytucjonalny, wyłącznie w sprawie bezpośrednio związanej z obszarem zawodowym odbiorcy i ograniczoną liczbę razy.",
          "Sam fakt publicznej dostępności danych w internecie nie stanowi samodzielnej podstawy prawnej. Rada Ochrony Danych Osobowych uznała, że publiczny charakter danych nie czyni ich użytecznymi do każdego celu i że zamiar oraz cel ich upublicznienia należy oceniać odrębnie; z tego powodu nie powołuje się na art. 5/2-(d).",
        ],
      },
      {
        heading: "5. Transfery i okres przechowywania",
        paras: [
          "Korespondencja jest prowadzona za pośrednictwem dostawcy poczty elektronicznej, którego infrastruktura może znajdować się za granicą; takie transfery odbywają się z zastosowaniem odpowiednich zabezpieczeń na podstawie art. 9 KVKK.",
          "Państwa dane są usuwane z chwilą ustania celu kontaktu lub na Państwa żądanie. Po żądaniu usunięcia zachowywany jest ściśle ograniczony wpis „nie kontaktować”, wyłącznie po to, aby nie doszło do ponownego kontaktu; nigdy nie jest on wykorzystywany do wysyłki.",
        ],
      },
      {
        heading: "6. Handlowe wiadomości elektroniczne i prawo odmowy",
        paras: [
          "Wiadomości o charakterze promocyjnym są objęte zakresem ustawy nr 6563 o regulacji handlu elektronicznego. Mogą Państwo odmówić ich otrzymywania bez podania jakiejkolwiek przyczyny; odmowy są realizowane najpóźniej w ciągu trzech dni roboczych, po czym nie jest wysyłana żadna kolejna wiadomość promocyjna. Wystarczy odpowiedzieć na otrzymaną wiadomość albo napisać na adres " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Państwa prawa",
        paras: [
          "Na podstawie art. 11 KVKK przysługuje Państwu prawo do uzyskania informacji, czy Państwa dane osobowe są przetwarzane, do żądania informacji na ich temat, do poznania celu przetwarzania i tego, czy dane są wykorzystywane zgodnie z tym celem, do poznania osób trzecich, którym dane są przekazywane w Turcji lub za granicą, do żądania sprostowania danych niepełnych lub nieprawidłowych, do żądania ich usunięcia lub zniszczenia, do żądania powiadomienia o tych czynnościach osób trzecich, do sprzeciwu wobec niekorzystnego dla Państwa rozstrzygnięcia wynikającego wyłącznie z analizy zautomatyzowanej oraz do żądania naprawienia poniesionej szkody.",
          `Żądania można kierować na adres ${MERCHANT.email}; odpowiedź jest udzielana najpóźniej w ciągu trzydziestu dni. Zachowują Państwo również prawo do wniesienia skargi do Rady Ochrony Danych Osobowych.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Polityka plików cookie",
    description: "Rodzaje stosowanych plików cookie, ich cele oraz zarządzanie preferencjami.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Platforma wykorzystuje pliki cookie i podobne technologie pamięci lokalnej (localStorage), aby utrzymać Państwa sesję i zapamiętać Państwa preferencje.",
        ],
      },
      {
        heading: "Stosowane technologie",
        bullets: [
          "Ściśle niezbędne: token sesji/uwierzytelnienia, bezpieczeństwo. Bez nich usługa nie działa.",
          "Funkcjonalne: preferencja języka i regionu (NEXT_LOCALE), preferencje interfejsu (np. motyw).",
          "Wydajnościowe i bezpieczeństwa: techniczne logi na potrzeby limitowania żądań i wykrywania nadużyć.",
        ],
      },
      {
        heading: "Zarządzanie preferencjami",
        paras: [
          "Pliki cookie można usunąć lub zablokować w przeglądarce; zablokowanie plików ściśle niezbędnych uniemożliwi jednak logowanie i korzystanie z podstawowych funkcji. Zgodnie z zasadami RODO / ePrivacy oraz Przewodnikiem KVKK dotyczącym plików cookie pliki nieniezbędne są stosowane wyłącznie na podstawie Państwa wyraźnej preferencji lub zgody.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "O nas",
    description:
      "Cel PsyPractice, świadczona usługa oraz dane kontaktowe przedsiębiorcy (sprzedawcy).",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice to platforma symulacji pacjenta i rozwijania umiejętności klinicznych wspierana sztuczną inteligencją, stworzona dla studentów psychologii oraz świeżo upieczonych, początkujących klinicystów. Użytkownicy prowadzą tekstowe sesje terapeutyczne; na koniec każdej sesji superwizor AI ocenia rozmowę i tworzy rozwojowy raport zwrotny. Pacjent AI przenosi relację terapeutyczną z sesji na sesję dzięki pamięci obejmującej wiele sesji.",
        ],
      },
      {
        heading: "Nasza misja",
        paras: [
          "Naszym celem jest dać przyszłym specjalistom zdrowia psychicznego bezpieczne, powtarzalne środowisko, w którym mogą ćwiczyć umiejętności prowadzenia rozmowy bez jakiegokolwiek ryzyka wyrządzenia krzywdy prawdziwym klientom. PsyPractice nie jest usługą edukacyjną ani szkoleniową; jest narzędziem programistycznym, które pozwala użytkownikowi prowadzić i zapisywać własną praktykę. Nie jest prawdziwą terapią ani poradnictwem, nie zastępuje superwizji klinicznej, nie jest narzędziem diagnostycznym ani oceniającym i nie wolno z niego korzystać w sytuacjach kryzysowych ani nagłych.",
        ],
      },
      {
        heading: "Co oferujemy",
        bullets: [
          "Symulację tekstowych sesji terapeutycznych z różnorodnymi profilami pacjentów zsyntetyzowanymi z literatury klinicznej.",
          "Automatyczne raporty oceny superwizyjnej po każdej sesji.",
          "Model „żywego pacjenta” z pamięcią obejmującą wiele sesji, dzięki której relacja terapeutyczna rozwija się w czasie.",
          "Tworzenie własnych pacjentów: student może wygenerować swój przypadek z pomocą AI.",
          "Metryki postępu śledzące rozwój mikroumiejętności.",
        ],
      },
      {
        heading: "Sprzedawca / dane działalności",
        bullets: [
          `Nazwa: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.addressEn}`,
          `Urząd skarbowy / numer podatkowy: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Strona internetowa: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Umowa sprzedaży na odległość",
    description:
      "Sprzedawca, kupujący, usługa, cena, płatność, wykonanie oraz warunki prawa odstąpienia na gruncie tureckiej ustawy nr 6502 i Rozporządzenia o umowach zawieranych na odległość.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Strony",
        bullets: [
          `SPRZEDAWCA: ${MERCHANT.legalName} (${OWNER_TYPE}). Adres: ${MERCHANT.addressEn}. Urząd skarbowy / numer podatkowy: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "KUPUJĄCY: osoba fizyczna lub prawna, która zakłada konto na Platformie i nabywa płatną subskrypcję („Kupujący”).",
        ],
      },
      {
        heading: "2. Przedmiot Umowy",
        paras: [
          "Przedmiotem niniejszej Umowy jest określenie praw i obowiązków stron, zgodnie z turecką ustawą nr 6502 o ochronie konsumentów oraz Rozporządzeniem o umowach zawieranych na odległość, w zakresie sprzedaży i wykonania subskrypcji usługi cyfrowej nabytej drogą elektroniczną przez Kupującego za pośrednictwem Platformy, której właściwości i cena sprzedaży zostały wskazane poniżej.",
        ],
      },
      {
        heading: "3. Charakter usługi i cena",
        bullets: [
          "Przedmiotem sprzedaży są funkcje symulacji pacjenta wspieranej sztuczną inteligencją, oferowane w ramach płatnego planu subskrypcyjnego oprogramowania PsyPractice (usługa cyfrowa / prawo do korzystania z oprogramowania).",
          "PsyPractice nie jest usługą edukacyjną ani szkoleniową; jest narzędziem programistycznym, które pozwala użytkownikowi prowadzić i zapisywać własną praktykę. Opłata subskrypcyjna stanowi wynagrodzenie za dostęp do tego oprogramowania; nie jest opłatą za zajęcia, program nauczania, egzaminy, doradztwo ani jakikolwiek dokument.",
          "Zakres planu, okres (miesięczny, 4-miesięczny lub roczny) i aktualna cena są wyraźnie przedstawione na stronie cennika/płatności Platformy w chwili zakupu; łączna kwota wraz z podatkami jest podawana Kupującemu przed płatnością.",
          "Ceny obowiązują w walucie wyświetlanej na Platformie; o ile subskrypcja nie zostanie anulowana, odnawia się automatycznie po tej samej cenie z końcem wybranego okresu.",
          "W planach oferowanych jako „nielimitowane sesje” korzystanie podlega limitowi uczciwego korzystania (obecnie 60 sesji w miesiącu kalendarzowym). Po osiągnięciu limitu nowe sesje można ponownie rozpoczynać od pierwszego dnia następnego miesiąca kalendarzowego; nie uprawnia to do obniżenia ceny ani zwrotu. Limit ma zapobiegać udostępnianiu kont i korzystaniu zautomatyzowanemu, a Sprzedawca nie zmienia go na niekorzyść Kupującego w opłaconym okresie subskrypcji.",
        ],
      },
      {
        heading: "4. Płatność",
        paras: [
          "Płatności są pobierane w bezpieczny sposób kartą kredytową lub debetową za pośrednictwem licencjonowanej instytucji płatniczej iyzico. Dane karty nie są przechowywane przez Sprzedawcę; płatność jest realizowana w bezpiecznych systemach iyzico. W przypadku płatności cyklicznych (subskrypcyjnych) kwota jest automatycznie pobierana w każdym okresie odnowienia z karty zatwierdzonej przez Kupującego.",
        ],
      },
      {
        heading: "5. Wykonanie i dostarczenie",
        paras: [
          "Usługa ma charakter cyfrowy i nie wiąże się z dostawą fizyczną. Po potwierdzeniu płatności funkcje subskrypcji są natychmiast udostępniane na koncie Kupującego. Wykonanie następuje drogą elektroniczną poprzez zapewnienie nieprzerwanego dostępu przez cały okres subskrypcji.",
        ],
      },
      {
        heading: "6. Prawo odstąpienia i wyjątek od niego",
        bullets: [
          "Zgodnie z art. 15 ust. 1 lit. (ğ) Rozporządzenia o umowach zawieranych na odległość prawo odstąpienia nie przysługuje w odniesieniu do dóbr i usług niematerialnych (cyfrowych) wykonywanych niezwłocznie w formie elektronicznej, jeżeli wykonanie rozpoczęto za zgodą Kupującego.",
          "Kupujący przyjmuje do wiadomości w chwili zakupu, że usługa zostanie wykonana natychmiast i że w związku z tym prawo odstąpienia nie przysługuje. Kupujący może w dowolnym momencie anulować subskrypcję, aby wstrzymać jej odnowienie; anulowanie staje się skuteczne z końcem bieżącego opłaconego okresu.",
          "Szczegółowe warunki zwrotu opisano w dokumencie „Warunki realizacji i zwrotu”.",
        ],
      },
      {
        heading: "7. Spory i wejście w życie",
        paras: [
          "W razie sporu Kupujący może zwrócić się do Komisji Arbitrażowej ds. Konsumentów lub do sądów konsumenckich właściwych dla swojego miejsca zamieszkania, w granicach kwotowych ogłoszonych przez Ministerstwo Handlu. Niniejsza Umowa zostaje zawarta i wchodzi w życie z chwilą jej zatwierdzenia przez Kupującego w formie elektronicznej.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Warunki realizacji i zwrotu",
    description:
      "Udostępnienie usługi cyfrowej, anulowanie subskrypcji, wyjątek od prawa odstąpienia oraz warunki zwrotu.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Realizacja (usługa cyfrowa)",
        bullets: [
          "PsyPractice jest usługą w pełni cyfrową; nie występuje wysyłka produktu fizycznego ani dostawa kurierska.",
          "Z chwilą potwierdzenia płatności funkcje subskrypcji są aktywowane automatycznie i natychmiast na koncie Kupującego; nie ma odrębnego czasu realizacji ani opłaty za dostawę.",
          "Dostęp do usługi odbywa się przez przeglądarkę internetową dowolnego urządzenia połączonego z internetem.",
        ],
      },
      {
        heading: "Anulowanie subskrypcji",
        bullets: [
          "Kupujący może w dowolnym momencie anulować subskrypcję w ustawieniach konta. Anulowanie staje się skuteczne z końcem bieżącego opłaconego okresu i wstrzymuje kolejne automatyczne odnowienie.",
          "Po anulowaniu dostęp do usługi trwa do końca opłaconego okresu.",
        ],
      },
      {
        heading: "Prawo odstąpienia i zwrot",
        bullets: [
          "Ponieważ usługa jest usługą cyfrową wykonywaną niezwłocznie za zgodą Kupującego, co do zasady nie powstaje prawo odstąpienia — a tym samym prawo do zwrotu — na podstawie art. 15 ust. 1 lit. (ğ) Rozporządzenia o umowach zawieranych na odległość.",
          "W przypadkach oczywistej wady, takich jak błędne lub podwójne obciążenie, całkowity brak możliwości dostępu do usługi z przyczyn technicznych lub sytuacje podobne, Kupujący może zażądać zwrotu, kontaktując się ze Sprzedawcą w rozsądnym terminie od daty płatności.",
          `Żądania zwrotu należy kierować na adres ${MERCHANT.email}; zatwierdzone zwroty są przekazywane na kartę użytą do płatności za pośrednictwem infrastruktury iyzico, co do zasady w ciągu 14 dni. Termin zwrotu może się różnić w zależności od czasu przetwarzania przez bank.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `We wszystkich sprawach dotyczących realizacji, anulowania i zwrotu: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
